import React from 'react';

const services = [
  { id: 1, icon: 'icofont-fire', title: 'Forced Air-Warming Systems', description: 'We provide top-quality forced air-warming systems designed to ensure optimal patient comfort during medical procedures.' },
  { id: 2, icon: 'icofont-bed', title: 'Forced Air-Warming Blankets', description: 'Our forced air-warming blankets are engineered to maintain body temperature, reducing the risk of hypothermia during surgeries.' }, // Changed to icofont-bed
  { id: 3, icon: 'icofont-heart-alt', title: 'Patient Comfort', description: 'Our products are designed with a focus on patient comfort, making sure the warmth is evenly distributed for maximum comfort.' },
  { id: 4, icon: 'icofont-hospital', title: 'Hospital Integration', description: 'Our warming systems integrate seamlessly into hospital and clinic environments, offering reliable solutions for patient care.' },
  { id: 5, icon: 'icofont-check-alt', title: 'High-Quality Standards', description: 'We are committed to providing only the highest quality products that meet rigorous healthcare standards and regulations.' },
  { id: 6, icon: 'icofont-brain-alt', title: 'Continuous Innovation', description: 'We are constantly innovating to improve the performance and efficiency of our warming systems, ensuring the latest technology in patient care.' },
];

const Serviceshome = () => {
  return (
    <section className="services section" style={{ backgroundColor: "#D3E3FD" }}>
      <div className="container">
        {/* Wallabies Warm Care Info */}
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title py-3">
              <h2 className='text-darkk'>Who Are We?</h2>
              <p>
                Wallabies Warm Care is the leading producer and supplier of forced air-warming systems and forced air-warming blankets. We take pride in serving society with quality products. Our products are designed to meet the needs of patients, ensuring their complete comfort during medical procedures.
              </p>
          
            </div>
          </div>
        </div>
        {/* End of Wallabies Warm Care Info */}

        {/* Services Section */}
        <div className="row">
          {services.map(service => (
            <div key={service.id} className="col-lg-4 col-md-6 col-12">
              <div className="single-service">
                <i className={`icofont ${service.icon}`}></i>
                <h4><a href="service-details.html">{service.title}</a></h4>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
        {/* End of Services Section */}
      </div>
    </section>
  );
};

export default Serviceshome;
